import {http} from './APIservice'

export default {
    login: (param1, param2) => {
        return http.get(`Usuario?userEmail=${param1}&userPassword=${param2}`)
    }
}